"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var CurtainsIcon = function CurtainsIcon(_ref) {
  var _ref$width = _ref.width,
    width = _ref$width === void 0 ? '20' : _ref$width,
    _ref$height = _ref.height,
    height = _ref$height === void 0 ? '20' : _ref$height;
  return /*#__PURE__*/_react.default.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: width,
    height: height,
    viewBox: "0 0 19 19",
    fill: "none"
  }, /*#__PURE__*/_react.default.createElement("path", {
    d: "M1.58887 16.1262V15.0012H3.08887V3.37622H14.3388V15.0012H15.8388V16.1262H1.58887ZM4.21385 15.0012H7.35665C7.25665 14.0781 6.95232 13.1505 6.44367 12.2183C5.93501 11.286 5.19174 10.6863 4.21385 10.419V15.0012ZM4.21385 4.5012V9.08342C5.19174 8.81612 5.93501 8.21637 6.44367 7.28415C6.95232 6.35193 7.25665 5.42428 7.35665 4.5012H4.21385ZM5.46431 9.7512C6.38642 10.2464 7.09796 10.9911 7.59892 11.9853C8.09989 12.9796 8.39653 13.9849 8.48883 15.0012H8.93887C9.03117 13.9849 9.32781 12.9796 9.82878 11.9853C10.3297 10.9911 11.0413 10.2464 11.9634 9.7512C11.0365 9.25602 10.3225 8.5113 9.82156 7.51707C9.3206 6.52284 9.02396 5.51755 8.93165 4.5012H8.48883C8.39653 5.51755 8.09989 6.52284 7.59892 7.51707C7.09796 8.5113 6.38642 9.25602 5.46431 9.7512ZM13.2139 4.5012H10.0638C10.1638 5.42428 10.4682 6.35193 10.9768 7.28415C11.4855 8.21637 12.2312 8.81612 13.2139 9.08342V4.5012ZM13.2139 15.0012V10.419C12.2312 10.6863 11.4886 11.286 10.9862 12.2183C10.4838 13.1505 10.1826 14.0781 10.0826 15.0012H13.2139Z",
    stroke: "none",
    fillRule: "nonzero",
    fill: "#75767A",
    fillOpacity: 1
  }));
};
CurtainsIcon.propTypes = {
  width: _propTypes.default.string,
  height: _propTypes.default.string
};
CurtainsIcon.defaultProps = {
  width: 24,
  height: 24
};
var _default = CurtainsIcon;
exports.default = _default;